var map = {
	"./10_of_clubs.svg": 1044,
	"./10_of_diamonds.svg": 9894,
	"./10_of_hearts.svg": 5918,
	"./10_of_spades.svg": 8543,
	"./2_of_clubs.svg": 1161,
	"./2_of_diamonds.svg": 2805,
	"./2_of_hearts.svg": 6329,
	"./2_of_spades.svg": 5436,
	"./3_of_clubs.svg": 2910,
	"./3_of_diamonds.svg": 2644,
	"./3_of_hearts.svg": 7464,
	"./3_of_spades.svg": 585,
	"./4_of_clubs.svg": 2335,
	"./4_of_diamonds.svg": 6327,
	"./4_of_hearts.svg": 9799,
	"./4_of_spades.svg": 6674,
	"./5_of_clubs.svg": 3588,
	"./5_of_diamonds.svg": 742,
	"./5_of_hearts.svg": 1966,
	"./5_of_spades.svg": 3535,
	"./6_of_clubs.svg": 4125,
	"./6_of_diamonds.svg": 6537,
	"./6_of_hearts.svg": 9285,
	"./6_of_spades.svg": 6792,
	"./7_of_clubs.svg": 7810,
	"./7_of_diamonds.svg": 7208,
	"./7_of_hearts.svg": 5620,
	"./7_of_spades.svg": 5925,
	"./8_of_clubs.svg": 2771,
	"./8_of_diamonds.svg": 4811,
	"./8_of_hearts.svg": 6707,
	"./8_of_spades.svg": 5246,
	"./9_of_clubs.svg": 1896,
	"./9_of_diamonds.svg": 3658,
	"./9_of_hearts.svg": 2186,
	"./9_of_spades.svg": 2315,
	"./ace_of_clubs.svg": 5352,
	"./ace_of_diamonds.svg": 9898,
	"./ace_of_hearts.svg": 9882,
	"./ace_of_spades.svg": 1179,
	"./jack_of_clubs.svg": 3274,
	"./jack_of_diamonds.svg": 6528,
	"./jack_of_hearts.svg": 6892,
	"./jack_of_spades.svg": 2797,
	"./king_of_clubs.svg": 3038,
	"./king_of_diamonds.svg": 1236,
	"./king_of_hearts.svg": 6008,
	"./king_of_spades.svg": 5481,
	"./queen_of_clubs.svg": 2309,
	"./queen_of_diamonds.svg": 5457,
	"./queen_of_hearts.svg": 7789,
	"./queen_of_spades.svg": 5888
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9510;